import { React } from 'react';
import { Flex, Divider } from '@chakra-ui/react';
import StyledAccordionItem from './StyledAccordionItem';
import GreyTextBox from './GreyTextBox';

function CandidateAccordion({ interview }) {
  return (
    <StyledAccordionItem title='Candidate Information'>
      <Flex gap='12'>
        <Flex flexDirection='column' flex='2'>
          <GreyTextBox
            title='Point of Contact:'
            text={
              interview.candidateData.Snapshot_Source_Activation
                ? `${interview.candidateData.Snapshot_Source_Activation}${
                    interview.candidateData.Snapshot_Source_Activation_Email
                      ? ` (${interview.candidateData.Snapshot_Source_Activation_Email})`
                      : ''
                  }`
                : undefined
            }
          />
          <GreyTextBox title='Email:' text={interview.candidateData.Snapshot_Email} />
          <GreyTextBox title='Interview Date:' text={interview.interviewData.Interview_Date} />
          <GreyTextBox title='Roles:' text={interview.candidateData.Snapshot_Roles?.join(', ')} />
          <GreyTextBox title='Seniority:' text={interview.candidateData.Snapshot_Seniority?.join(', ')} />
        </Flex>
        <Flex flexDirection='column' flex='3'>
          <GreyTextBox
            title='Years of full-time experience:'
            text={interview.candidateData.Snapshot_Years_of_full_time_experience}
          />
          <GreyTextBox title='CS Engineer or Systems degree:' text={interview.candidateData.Snapshot_CS_degree} />
          <GreyTextBox title='English level:' text={interview.candidateData.Snapshot_English_level} />
          <GreyTextBox title='Tech stack:' text={interview.candidateData.Snapshot_Tech_stack?.join(', ')} />
          <GreyTextBox title='Current Job title:' text={interview.candidateData.Snapshot_Job_title} />
        </Flex>
      </Flex>

      {(interview.candidateData.Snapshot_Expected_monthly_salary_USD ||
        interview.candidateData.Snapshot_Ideal_opportunity ||
        interview.candidateData.Snapshot_Looking_to_change_jobs ||
        interview.candidateData.Snapshot_Company_size_preference?.length ||
        interview.candidateData.Snapshot_Recruiting_Notes) && (
        <>
          <Divider my='24px' />
          <Flex gap='12'>
            <Flex flexDirection='column'>
              <GreyTextBox
                title='Expected monthly salary (USD):'
                text={interview.candidateData.Snapshot_Expected_monthly_salary_USD}
              />
              <GreyTextBox title='Ideal Opportunity:' text={interview.candidateData.Snapshot_Ideal_opportunity} />
              <GreyTextBox
                title='Looking to change jobs:'
                text={interview.candidateData.Snapshot_Looking_to_change_jobs}
              />
              <GreyTextBox
                title='Company size preference:'
                text={interview.candidateData.Snapshot_Company_size_preference?.join(', ')}
              />
              <GreyTextBox
                title='Recruiting Notes:'
                text={interview.candidateData.Snapshot_Recruiting_Notes}
                textBold
              />
            </Flex>
          </Flex>
        </>
      )}
    </StyledAccordionItem>
  );
}

export default CandidateAccordion;
